import { useEffect, useRef } from "react";
import { useAuthStore } from "../store/authStore";

// Default timeout: 30 minutes in milliseconds
const DEFAULT_TIMEOUT = 30 * 60 * 1000;

export function useIdleSession(timeoutMs: number = DEFAULT_TIMEOUT) {
  const { isAuthenticated, logout } = useAuthStore();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const handleIdleTimeout = () => {
      logout();
      // Optionally trigger a custom event or toast here if needed
      // toast.error("Session expired due to inactivity");
    };

    const resetTimer = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(handleIdleTimeout, timeoutMs);
    };

    // Initialize timer
    resetTimer();

    // Events that reset the idle timer
    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];

    // Add event listeners
    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [isAuthenticated, logout, timeoutMs]);
}
